import React from 'react'
import './Product.css'
import '../../Reviews/Reviews.css'
import { Link } from 'react-router-dom';
import Rating from '@mui/material/Rating';

const Product = ({ product }) => {
  const { _id, img1, img2, name, price, averageRating, totalReviews } = product;
  return (
    <div className='productCard'>
      <Link to={`/shop/${_id.substr(1, 5)}`} state={{ product }}>
        <div className='productImage'>
          <img id='hideOnHover' src={img1} alt="prdouct1a" />
          <img src={img2} alt="prdouct1b" />
        </div>
        <div className='productDetail'>
          <h5>{name}</h5>
          {totalReviews > 0 && (
            <div className='productCardRating'>
              <Rating value={averageRating ?? 0} readOnly size="small" precision={0.5} />
            </div>
          )}
          <p>{`$ ${price}`}</p>
        </div>
      </Link>
    </div>
  )
}
export default Product;
